<template>

  <!-- Mobile -->
  <div class="timeline-container-mobile mx-3 d-block d-lg-none">
    <h2 class="timeline-title-mobile heading">
      {{ content.planning_traintimeline_title }}
    </h2>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-solid-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile">
          <strong>{{ content.planning_traintimeline_arrival_1 }}</strong> {{ content.planning_traintimeline_arrival_2 }} {{ trainStationName }}</div>
        <div class="custom-badge-mobile badge-train-mobile">
          <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />          
          {{ content.planning_traintimeline_departure_name }}
        </div>
      </div>
    </div>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-dotted-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>{{ content.planning_traintimeline_arrival_3 }}</strong> {{ content.planning_traintimeline_arrival_4 }}</div>
        <div class="custom-badge-mobile badge-transfer-mobile">
          <TransferSvgIcon color="var(--primary-black)" :width="16" :height="16" fill="var(--primary-black)" stroke="var(--primary-black)" />
          {{ content.planning_traintimeline_arrival_transfer }}
        </div>
      </div>
    </div>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-solid-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>{{ content.planning_traintimeline_checkin_1 }}</strong> {{ content.planning_traintimeline_checkin_2 }}</div>
        <div class="custom-badge-mobile badge-stay-mobile">
          <SkiSvgIcon color="var(--primary-white)" :width="16" :height="16" fill="var(--primary-white)" stroke="var(--primary-white)" />            
          {{ content.planning_traintimeline_stay }}
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-dotted-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>{{ content.planning_traintimeline_ski_1 }}</strong> {{ content.planning_traintimeline_ski_2 }}</div>
        <div class="custom-badge-mobile badge-transfer-mobile">
          <TransferSvgIcon color="var(--primary-black)" :width="16" :height="16" fill="var(--primary-black)" stroke="var(--primary-black)" />
          {{ content.planning_traintimeline_transfer_return }}
        </div>
      </div>
    </div>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-solid-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>{{ content.planning_traintimeline_return_1 }}</strong> {{ content.planning_traintimeline_return_2 }}</div>
        <div class="custom-badge-mobile badge-train-mobile">
          <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
          {{ content.planning_traintimeline_return_name }}
        </div>
      </div>
    </div>
    
    <div class="d-flex">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
      </div>
      <div class="timeline-content-mobile">
        <div class="timeline-text-mobile mb-0"><strong>{{ content.planning_traintimeline_return_3 }}</strong> {{ content.planning_traintimeline_return_4 }} {{ trainStationName }}</div>
      </div>
    </div>

  </div>

  <!-- Desktop -->
  <div class="timeline-section d-none d-lg-block">

    <div class="timeline-section-title body-strong">
      {{ content.planning_traintimeline_title }}
    </div>
    
    <div class="timeline-track">
      
      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>{{ content.planning_traintimeline_arrival_1 }}</strong><br>{{ content.planning_traintimeline_arrival_2 }} {{ trainStationName }}
        </div>
      </div>

      <div class="segment">
        <div class="segment-solid"></div>
        <div class="badge-top">
          <span class="custom-badge badge-train m-0 p-1 px-2 subcaption-strong">
            <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
            {{ content.planning_traintimeline_departure_name }}
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>{{ content.planning_traintimeline_arrival_3 }}</strong><br>{{ content.planning_traintimeline_arrival_4 }}
        </div>
      </div>

      <div class="segment">
        <div class="segment-dotted"></div>
        <div class="badge-top">
          <span class="custom-badge badge-transfer m-0 p-1 px-2 subcaption-strong">
            <TransferSvgIcon color="var(--primary-black)" :width="16" :height="16" fill="var(--primary-black)" stroke="var(--primary-black)" />
            {{ content.planning_traintimeline_arrival_transfer }}
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle filled"></div>
        <div class="label-bottom subcaption">
          <strong>{{ content.planning_traintimeline_checkin_1 }}</strong><br>{{ content.planning_traintimeline_checkin_2 }}
        </div>
      </div>

      <div class="segment">
        <div class="segment-solid"></div>
        <div class="badge-top">
          <span class="custom-badge badge-stay m-0 p-1 px-2 subcaption-strong">
            <SkiSvgIcon color="var(--primary-white)" :width="16" :height="16" fill="var(--primary-white)" stroke="var(--primary-white)" />            
            {{ content.planning_traintimeline_stay }}
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle filled"></div>
        <div class="label-bottom subcaption">
          <strong>{{ content.planning_traintimeline_ski_1 }}</strong><br>{{ content.planning_traintimeline_ski_2 }}
        </div>
      </div>

      <div class="segment">
        <div class="segment-dotted"></div>
        <div class="badge-top">
          <span class="custom-badge badge-transfer m-0 p-1 px-2 subcaption-strong">
            <TransferSvgIcon color="var(--primary-black)" :width="16" :height="16" fill="var(--primary-black)" stroke="var(--primary-black)" />
            {{ content.planning_traintimeline_transfer_return }}
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>{{ content.planning_traintimeline_return_1}}</strong><br>{{ content.planning_traintimeline_return_2 }}
        </div>
      </div>

      <div class="segment">
        <div class="segment-solid"></div>
        <div class="badge-top">
          <span class="custom-badge badge-train m-0 p-1 px-2 subcaption-strong">
            <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
            {{ content.planning_traintimeline_return_name }}
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>{{ content.planning_traintimeline_return_3 }}</strong><br>{{ content.planning_traintimeline_return_4 }} {{ trainStationName }}
        </div>
      </div>

    </div>
  </div>

  
  
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import TrainSvgIcon from "./svg/trainSvgIcon.vue";
import TransferSvgIcon from "./svg/transferSvgIcon.vue";
import SkiSvgIcon from "./svg/skiSvgIcon.vue";

const store = useStore();

const content = computed(() => store.state.content);

const trainStationName = computed(() => {
  return content.value['planning_traintimeline_station_short_'+store.state.flightOrigin];
});
</script>

<style scoped>



/* Conteneur principal */
.timeline-container-mobile {
  background-color: #e2e8f4;
  border-radius: 16px;
  padding: 30px 20px;
  max-width: 450px;
  font-family: system-ui, -apple-system, sans-serif;
  margin: 20px auto;
}

.timeline-title-mobile {
  font-weight: 900;
  font-size: 1.4rem;
  color: #212529;
  margin-bottom: 30px;
  letter-spacing: -0.5px;
}

/* --- Colonne Visuelle (Traits et points) --- */
.timeline-visual-mobile {
  min-width: 24px;
}

.timeline-point-mobile {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid var(--primary-blue);
  background-color: #e2e8f4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
}

.timeline-point-mobile::after {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--primary-blue);
}

.timeline-line-mobile {
  width: 2px;
  margin-top: 4px;
  margin-bottom: -16px;
}

.line-solid-mobile {
  background-color: var(--primary-blue);
}

.line-dotted-mobile {
  background-color: transparent;
  border-left: 3px dotted var(--primary-white);
  width: 3px;
}

/* --- Contenu et Textes --- */
.timeline-text-mobile {
  font-size: 0.95rem;
  color: #212529;
  line-height: 1.4;
  margin-bottom: 12px;
  text-wrap: nowrap;  
}

/* --- Badges --- */
.custom-badge-mobile {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 700;
}

.badge-train-mobile {
  background-color: var(--primary-white);
  color: var(--primary-blue);
  border: 1px solid var(--primary-white); 
}

.badge-transfer-mobile {
  background-color: transparent;
  color: #111111;
  border: 1px solid var(--primary-blue);
}

.badge-stay-mobile {
  background-color: var(--blue-800);
  color: var(--primary-white);
  border: 1px solid var(--blue-800);
}




@media only screen and (min-width: 960px) {

  /* Conteneur principal avec la couleur de fond de l'image */
  .timeline-section {
    background-color: var(--blue-200);
    padding: 70px 60px 60px 60px;
    overflow: none;
    border-radius: 24px;
  }

  .timeline-section-title {
    position: relative;
    top: -45px;
    left: -40px;
  }

  .timeline-track {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 950px; /* Force une largeur minimale pour éviter l'écrasement */
    max-width: 1300px;
    margin: 0 auto;
  }

  /* --- Nœuds (Points) --- */
  .point {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
  }

  .circle {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid var(--primary-blue);
    background-color: var(--primary-white);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Le petit point bleu à l'intérieur des cercles vides */
  .circle::after {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: var(--primary-blue);
  }

  /* Cercles pleins pour les étapes centrales */
  .circle.filled {
    background-color: var(--primary-blue);
  }
  .circle.filled::after {
    display: none; /* Cache le petit point interne */
  }

  /* --- Segments de ligne --- */
  .segment {
    flex-grow: 1;
    position: relative;
    height: 14px; /* Même hauteur que les cercles pour l'alignement vertical */
    display: flex;
    align-items: center;
    z-index: 1;
  }

  .segment-solid {
    width: 100%;
    height: 2px;
    background-color: var(--primary-blue);
  }

  .segment-dotted {
    width: 100%;
    border-top: 3.5px dotted var(--primary-white);
  }

  /* --- Textes et Badges --- */
  .label-bottom {
    position: absolute;
    top: 25px;
    text-align: center;
    color: var(--grey-900);
    white-space: nowrap;
    line-height: 1.4;
  }

  .badge-top {
    position: absolute;
    bottom: 22px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }

  .custom-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-radius: 50px;
  }

  /* Styles spécifiques aux différents badges */
  .badge-train {
    background-color: var(--primary-white);
    color: var(--primary-blue);
  }

  .badge-transfer {
    background-color: transparent;
    color: #212529;
    border: 1px solid #8da6ce;
  }

  .badge-stay {
    background-color: var(--blue-800);
    color: var(--primary-white);
    border: 1px solid var(--blue-800);
  }
}
</style>
